import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideaimpact() {
  return (
    <section className="ideai_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto resp_order text-center"
          >
            <div className="intro_impact">
              <StaticImage
                src="../../../images/case-studies/impact/idea_behind.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={825}
                height={660}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>The Idea Behind Project Impact</h2>
            <p>
              According to research, the two most critical skills required for
              academic success were understanding and managing emotions. For
              this reason, it was important for educational organizations to
              determine the students with a low level of E.Q.
            </p>
            <p>
              Therefore, to extract the number of students with a low level of
              E.Q, Project MS Impact wanted to develop a web app that would have
              specific functionality and features aimed towards not only
              identifying problems or communications issues within the
              institutes but also give them insights into the emotional
              intelligence level of the students.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideaimpact;
